export const CreateCustomerReview = async ({
		name,
		surname,
		email,
		address,
		mobile,
		postalCode,
		postalArea,
		color,
		rate,
		size,
		review,
	}: {
	name: string,
	surname: string,
	email: string,
	address: string,
	mobile: string,
	postalCode: string,
	postalArea: string,
	color: string,
	rate: string,
	size: string,
	review: string,
}) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://kosiband-server.onrender.com'}/api/customer/create-customer`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Cache-Control': 'no-cache',
			},
			credentials: 'include',
			body: JSON.stringify({
				name,
				surname,
				email: email.toLowerCase(),
				address,
				mobile,
				postalCode,
				postalArea,
				color,
				rate,
				size,
				review,
			})
		});
		const data = await response.json();
		if (response && response.status === 201 && data) {
			console.log("CreateCustomer data: ", data);
			return data;
		} else {
			alert('Submission failed. Please try again.');
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (error) {
		console.error("CreateCustomer error: ", error);
	}
}


export const CreateCustomerReferredFriend = async ({
	customerEmail,
	name,
	surname,
	email,
	address,
	mobile,
	postalCode,
	postalArea,
	color,
	size,
}: {
	customerEmail: string,
	name: string,
	surname: string,
	email: string,
	address: string,
	mobile: string,
	postalCode: string,
	postalArea: string,
	color: string,
	size: string,
}) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://kosiband-server.onrender.com'}/api/referredFriend/create-referred-friend`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Cache-Control': 'no-cache',
			},
			credentials: 'include',
			body: JSON.stringify({
				customerEmail: customerEmail.toLowerCase(),
				name,
				surname,
				email: email.toLowerCase(),
				address,
				mobile,
				postalCode,
				postalArea,
				color,
				size,
			})
		});
		const data = await response.json();
		if (response && response.status === 201 && data) {
			console.log("CreateCustomer data: ", data);
			return data;
		} else {
			alert('Submission failed. Please try again.');
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (error) {
		console.error("CreateCustomer error: ", error);
	}
}